export default "__VITE_ASSET__1f3ca8e5__"